"use client";

import Modal from "@/components/ui/modal";
import ImageUpload from "./image-upload";
import { Editor } from "@tiptap/react";

const EditorImageUploadModal = ({
	isOpen,
	onClose,
	editor,
}: {
	isOpen: boolean;
	onClose: () => void;
	editor: Editor | null;
}) => {
	return (
		<Modal title="Attach Image" isOpen={isOpen} onClose={onClose} className="max-w-sm">
			<ImageUpload editor={editor} onClose={onClose} />
		</Modal>
	);
};

export default EditorImageUploadModal;
